import { ArrowLeftRight } from 'lucide-react';
import { invertOf, coverOf, pipeSlope, fmtPm } from '../lib/sewer';

const f2 = (v) => (v == null ? '–' : v.toFixed(2).replace('.', ','));
const Num = ({ testid, value, ph, onChange }) => <input inputMode="decimal" data-testid={testid} value={value ?? ''} placeholder={ph} onChange={(e) => onChange(e.target.value)} />;

// manhole: cover elevation, invert depth -> invert elevation
export function ManholeLevels({ t, obj, patch }) {
  const sw = obj.sw || {};
  const set = (k) => (v) => patch({ sw: { ...sw, [k]: v } });
  return (
    <div className="fx-box sw-box" data-testid="manhole-levels">
      <b>🕳️ {t.swTitle}</b>
      <div className="sw-grid">
        <label>{t.swCover}<Num testid="manhole-cover-input" value={sw.cover} ph={coverOf(obj) != null ? f2(coverOf(obj)) : `m ${t.aslShort}`} onChange={set('cover')} /></label>
        <label>{t.swDepth}<Num testid="manhole-depth-input" value={sw.depth} ph="m" onChange={set('depth')} /></label>
        <label>{t.swInvert}<output data-testid="manhole-invert">{f2(invertOf(obj))} m</output></label>
      </div>
    </div>
  );
}

// sewer reach (Haltung): slope in ‰ / % between the two invert elevations
export function PipeSlope({ t, obj, patch, fittings }) {
  const s = pipeSlope(obj, fittings);
  if (!s) return null;
  const sw = obj.sw || {};
  const set = (k) => (v) => patch({ sw: { ...sw, [k]: v } });
  const linked = (i) => !Array.isArray(obj.points[i]) && obj.points[i]?.fid;
  return (
    <div className={`fx-box sw-box sw-${s.status || 'none'}`} data-testid="pipe-slope-box">
      <b>📉 {t.swSlopeTitle}</b>
      <div className="sw-grid">
        <label>{t.swFrom}{linked(0) && sw.zA == null ? <output data-testid="slope-za">{f2(s.zA)} m</output> : <Num testid="slope-za-input" value={sw.zA} ph={`m ${t.aslShort}`} onChange={set('zA')} />}</label>
        <label>{t.swTo}{linked(obj.points.length - 1) && sw.zB == null ? <output data-testid="slope-zb">{f2(s.zB)} m</output> : <Num testid="slope-zb-input" value={sw.zB} ph={`m ${t.aslShort}`} onChange={set('zB')} />}</label>
        <label>{t.swLen}<output>{f2(s.L)} m</output></label>
        <label>{t.swMin}<Num testid="slope-min-input" value={sw.min} ph={fmtPm(s.min ?? (obj.dn ? 1000 / obj.dn : 5))} onChange={set('min')} /></label>
      </div>
      {s.pm == null
        ? <small className="muted" data-testid="slope-need">{t.swNeed}</small>
        : <p className="sw-res" data-testid="slope-result"><b data-testid="slope-permille">{fmtPm(s.pm)}</b> · <span data-testid="slope-percent">{s.pct.toFixed(2).replace('.', ',')} %</span> · <span data-testid="slope-status">{s.status === 'neg' ? `⛔ ${t.swNeg}` : s.status === 'low' ? `⚠️ ${t.swLow}` : `✅ ${t.swOk}`}</span></p>}
      <button className="btn btn-outline btn-sm" data-testid="slope-reverse-btn" onClick={() => patch({ points: [...obj.points].reverse(), sw: { ...sw, zA: sw.zB, zB: sw.zA } })}><ArrowLeftRight size={13} /> {t.swReverse}</button>
    </div>
  );
}
